import { createContext } from 'react';
import type { FluxService } from '@/core/flux.service';

export const FluxContext = createContext<FluxService>(null as any);
